import { pricing } from "@/framework/billing/resourcePricing";
import { slicePaddingSeconds } from "@/modules/transcript/slicing/policies";

// 1 credit = 1 EUR net, so the public EUR prices double as credit prices.

// Listening in the podcast player transcribes one minute at a time, padded on
// both sides so consecutive slices can be overlapped when joined. The padding
// is billed, so a minute of listening costs more than a minute of a whole-track
// transcription. Derived from the slicing policy so the two can't drift apart.
export const billedSecondsPerListenedMinute = 60 + 2 * slicePaddingSeconds;

export const germanVatRate = 0.19;

// Hours of audio a balance buys when the whole track is transcribed in one go.
export function transcriptionHoursForCredits(credits: number): number {
  return credits / pricing.transcribed_hour.credits;
}

// Hours of audio a balance buys when transcribing minute-by-minute while listening.
export function listeningHoursForCredits(credits: number): number {
  return (
    transcriptionHoursForCredits(credits) *
    (60 / billedSecondsPerListenedMinute)
  );
}

// Characters of text a balance buys when spent entirely on translation.
export function translationCharactersForCredits(credits: number): number {
  return credits / pricing.translated_character.credits;
}

// Gross price of a topup: credits are net, VAT is added on top.
export function grossPriceForCredits(credits: number, vatRate: number): number {
  return Math.round(credits * (1 + vatRate) * 100) / 100;
}
